// Compiled file located in js/kleep.js (cf: config/script.js)
(function() {



	const anon_key = `${kleep_anon_key}`;
	const company_id = `${kleep_company_id}`;
	const basket_id = `${virtual_basket_id}`;


	// only load kleep if set to true
	if (window.enable_kleep_search !== '1') {
	    return;
	}


	if (typeof waitForKleepSearch !== "function") {
		function waitForKleepSearch(callback) {
			if (window.kleep && window.kleep.search) {
				callback();
			} else {
				setTimeout(function() {
					waitForKleepSearch(callback);
				}, 100);
			}
		}
	}


	// SW-22520 - The Kleep SDK is injected by GTM: when GTM is blocked (ad blocker, Firefox tracking protection), load it ourselves
	var kleepWidgetUrl = 'https://module.kleep.ai/api/widget';

	function loadKleepWidget() {
		if (window.kleep || document.querySelector('script[src^="' + kleepWidgetUrl + '"]')) {
			return;
		}

		var script = document.createElement('script');
		script.src = kleepWidgetUrl;
		script.async = true;
		document.head.appendChild(script);
	}

	if (document.readyState === 'complete') {
		loadKleepWidget();
	} else {
		window.addEventListener('load', loadKleepWidget);
	}


	var kleepInitialized = false;
	var openRequested = false;

	// Initialize search, then open it if the user clicked while the SDK was loading
	waitForKleepSearch(function() {

		window.kleep.search.init({
			anonKey: anon_key,
			companyId: company_id
		});

		kleepInitialized = true;

		if (openRequested) {
			openRequested = false;
			// renderBox needs window.KleepSearch, created asynchronously by init
			waitForKleepSearchApp(renderKleepBox);
		}
	});

	function waitForKleepSearchApp(callback) {
		if (window.KleepSearch) {
			callback();
		} else {
			setTimeout(function() {
				waitForKleepSearchApp(callback);
			}, 100);
		}
	}

	function openKleepSearch() {
		if (kleepInitialized) {
			waitForKleepSearchApp(renderKleepBox);
		} else {
			openRequested = true;
		}
	}

	// Attach click handler (desktop + mobile) right away, so an early click is not lost
	var btnDesktop = document.getElementById("trigger_recherche");
	var btnMobile = document.getElementById("search_homeV2");

	[btnDesktop, btnMobile].forEach(function(btn) {
		if (btn) {
			btn.addEventListener("click", openKleepSearch);
		}
	});

	function renderKleepBox() {

		window.kleep.search.renderBox("search-mount", {

			onClose: function() {
				var shadMenu = document.getElementById('shad_menu');
				if (shadMenu) {
					shadMenu.classList.remove('actif_search');
				}
			},

			onSearchSubmit: function(query) {
			},

			getWishlistItems: function() {
			},

			toggleWishlist: function(data) {
			},

			addToCart: function(data) {
				// Check product ref (ean on kleep)
				if (!data.variant_ref) {
					console.error(data, "No product_ref received from Kleep.");
					return;
				}

				var data = {
					gencode: data.variant_ref,
					qte: 1,
					panierid: basket_id,
					dataTypeReturn: 'json'
				};

				$.ajax({
					url: path_relative_root + create_link('ajax_update_basket'),
					type: 'post',
					dataType: 'json',
					data: data,
					success: function(res) {
						if (res.error !== 0) {
							alert(res.error.msg);
						} else {
							var closeBtn = document.querySelector('#search-mount button');
                            if (closeBtn) {
                                // Trigger the close
                                closeBtn.click();
                            }
							var response = ajax_file(path_relative_root + "ajax_show_basket.php");
							document.getElementById('cart_top').innerHTML = response;
							var cartBox = document.getElementById("show_top_cart");
							if (cartBox) {
								// Add animation class
								cartBox.classList.add("appear");
							}
						}
					}
				});
			},
		});
	}
})();